import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-invite',
    templateUrl: './icon-invite.component.html',
    styleUrls: ['./icon-invite.component.scss']
})
export class IconInviteComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
